import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Dropdown = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      fill-rule="nonzero"
      d="M23 1v11h-1V2H2v10H1V1h22Zm-3.536 4.25L16 9l-3.464-3.75h6.928ZM1 14h22v1H1Zm0 3h22v1H1Zm0 3h22v1H1Z"
    />{' '}
  </SvgIcon>
);

export default Dropdown;
